import { PlatformClient as BaseClient } from '../api/client'

export default class Event {
    constructor(url) {
        this.host = url
        this.subscribers = {}
        this.socket = null
        this.env = localStorage.getItem("current_env")
        this.token = null
        this.platformClient = new BaseClient()

        this.platformClient.http.interceptors.request.use(function(config) {
            config.headers["X-Project-Uuid"] = localStorage.getItem("current_project_uuid")
            config.headers["X-Workspace-Uuid"] = localStorage.getItem("current_workspace_uuid")
            
            if (config.headers["X-Project-Env"] === undefined)
              config.headers["X-Project-Env"] = localStorage.getItem("current_env")
          
            return config
        });

        // event listeners
        this.onerror = () => {}
        this.onclose = () => {}
    }

    auth() {
        return new Promise((resolve, reject) => {
            this.platformClient.http.post("/v1/system/eventbus/auth").then(resp => {
                const { data } = resp
                this.token = data.token
                
                resolve(this.token)
            }).catch(err => {
                reject(err)
            })
        })
    }

    async connect() {
        const env = this.env
        const uuid = localStorage.getItem("current_project_uuid")
        this.subscribers = {}

        try {
            await this.auth()

            const host = `${this.host}/${uuid}?token=${this.token}`
            this.socket = new WebSocket(host);

            console.log(`[Event] Establishing connection on ${host} - ${env}`)

            this.socket.addEventListener('error', (event) => {
                console.log("[Event] Error", event)    

                this.onerror()
            })

            this.socket.addEventListener('message', (event) => {
                let data = JSON.parse(event.data)

                if (data.token) {
                    console.log(`[Event] Auth received`, event)

                    this.token = data.token
                    return
                }

                console.log(`[Event] Received`, event)

                const handlers = this.subscribers[data.topic] || []

                handlers.forEach(h => {
                    console.log("[Event] Handler ", event)

                    h(data)
                })
            })

            this.socket.addEventListener('open', () => {
                console.log("[Event] Connected")
            })

            this.socket.addEventListener('close', (event) => {
                console.log("[Event] Disconnected", event)

                if (event.code == 1000) {
                    const reason = JSON.parse(event.reason) || null
                    if (reason && reason.code == 401) {
                        throw new Error("Unauthorized")
                    }
                }
                
                if (event.code == 1006) {
                    setTimeout(() => this.connect(), 5000)
                }

                if (event.code == 3002) {
                    this.connect()
                }

                this.onclose()
            })

        } catch(err) {
            console.error(err)
        }
    }

    client() {
        return this
    }

    subscribe(topic, handler) {
        const t = `${topic}.${this.env}`
        
        if (this.subscribers[t]) {
            this.subscribers[t].push(handler)
        } else {
            this.subscribers[t] = [handler]
        }

        console.log('[Event] Current subscribers', this.subscribers)
    }

    publish(topic, payload) {
        topic = `${topic}.${this.env}`
        this.socket.send(JSON.stringify({
            topic,
            payload
        }))
    }

    close() {
        console.log("[Event] Closing connection")
        if (this.socket) {
            this.socket.close()
        }
    }

    onclose(cb) {
        this.onclose = cb
    }

    onerror(cb) {
        this.onerror = cb
    }
}